import React from 'react';
import Layout from '../Layout/Layout';
import {Route, Switch, Redirect} from 'react-router-dom';
import BillingStatus from '../../pages/BillingStatus/BillingStatus';
import BillingInformation from '../../pages/BillingInformation/BillingInformation';
import AddPaymentMethod from '../../pages/AddPaymentMethod/AddPaymentMethod';

const Dashboard = () => {
  return (
    <Layout>
      <Switch>
        <Route path="/" exact component={BillingStatus} />
        <Route path="/billinginfo" exact component={BillingInformation} />
        <Route path="/addpaymentmethod" exact component={AddPaymentMethod} />
        <Redirect to="/" />
      </Switch>
    </Layout>
  );
};

export default Dashboard;